import AntIcon from "@/components/icons/AntIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { serializeParams } from "@/utils/apiUtils";
import { useWindowSize } from "@/utils/hooksUtils";
import { numberOrZero } from "@/utils/utils";
import { Button, Col, Flex, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useGetDashboardContractStatuses } from "../../../../../common/api/queries";
import { useCurrentAgentAccount } from "../../../../auth/hooks";
import { ContractVerificationStatus } from "../../../../contract/enums";
import { CONTRACT_ROUTE_PATHS } from "../../../../contract/paths";
import { DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH } from "../../../utils";
import { InfoCard } from "./components/InfoCard";
import { ShowMoreButton } from "./components/ShowMoreButton";

export const DashboardContractStatusesWidget = () => {
  const { t } = useTranslation();

  const windowSize = useWindowSize();

  const userAccount = useCurrentAgentAccount();

  const { data: contractStatuses } = useGetDashboardContractStatuses();

  const isInterventionDisabled =
    (contractStatuses?.externalInterventionContractsCount ||
      contractStatuses?.internalInterventionContractsCount ||
      contractStatuses?.internalAndExternalInterventionContractsCount) == null;
  const isUnpaidInsuranceContractDisabled = contractStatuses?.unpaidInsuranceContractCount == null;
  const isAnniversaryDatesInsurancesDisabled = contractStatuses?.insuranceContractAnniversaryDatesCount == null;
  const isAnniversaryDatesLoansDisabled = contractStatuses?.loanContractAnniversaryDatesCount == null;

  const titleSize = windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? 20 : 20;

  return (
    <div style={{ height: "100%" }}>
      <Row
        gutter={windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? 24 : 12}
        style={{ height: "50%", paddingBottom: windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? 12 : 6 }}
      >
        <Col span={12}>
          <InfoCard
            disabled={isInterventionDisabled}
            label={
              <Flex align="center" justify="center">
                <Button
                  disabled={isInterventionDisabled}
                  variant="filled"
                  size="large"
                  color="red"
                  style={{ fontSize: 20 }}
                  icon={<AntIcon type="flag" />}
                />

                <span style={{ paddingLeft: 8, fontSize: titleSize }}>
                  {t("dashboard.contractStatuses.intervention")}
                </span>

                <ShowMoreButton
                  link={
                    CONTRACT_ROUTE_PATHS.list.to +
                    "?" +
                    serializeParams({
                      signerIds: [userAccount?.representingAgent?.id || userAccount?.agent?.id],
                      verificationStatuses: [
                        ContractVerificationStatus.INTERNAL_INTERVENTION,
                        ContractVerificationStatus.EXTERNAL_INTERVENTION,
                        ContractVerificationStatus.INTERNAL_AND_EXTERNAL_INTERVENTION,
                      ],
                    })
                  }
                />
              </Flex>
            }
            value={
              numberOrZero(contractStatuses?.externalInterventionContractsCount) +
              numberOrZero(contractStatuses?.internalInterventionContractsCount) +
              numberOrZero(contractStatuses?.internalAndExternalInterventionContractsCount)
            }
          />
        </Col>

        <Col span={12}>
          <InfoCard
            disabled={isUnpaidInsuranceContractDisabled}
            label={
              <Flex align="center" justify="center">
                <Button
                  variant="filled"
                  size="large"
                  color="orange"
                  style={{ fontSize: 20 }}
                  icon={<AntIcon type="euro" />}
                  disabled={isUnpaidInsuranceContractDisabled}
                />

                <Ellipsis>
                  <span style={{ paddingLeft: 8, fontSize: titleSize }}>
                    {t("dashboard.contractStatuses.unpaidInsuranceContract")}
                  </span>
                </Ellipsis>

                <ShowMoreButton
                  link={
                    CONTRACT_ROUTE_PATHS.unpaid.to +
                    "?" +
                    serializeParams({
                      gainerIds: [userAccount?.agent?.id],
                    })
                  }
                />
              </Flex>
            }
            value={numberOrZero(contractStatuses?.unpaidInsuranceContractCount)}
          />
        </Col>
      </Row>

      <Row
        gutter={windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? 24 : 12}
        style={{ height: "50%", paddingTop: windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? 12 : 6 }}
      >
        <Col span={12}>
          <InfoCard
            disabled={isAnniversaryDatesInsurancesDisabled}
            label={
              <Flex align="center" justify="center">
                <Button
                  disabled={isAnniversaryDatesInsurancesDisabled}
                  variant="filled"
                  size="large"
                  color="magenta"
                  style={{ fontSize: 20 }}
                  icon={<AntIcon type="alert" />}
                />

                <span style={{ paddingLeft: 12, fontSize: titleSize }}>
                  {t("dashboard.contractStatuses.anniversaryDatesInsurances")}
                </span>

                <ShowMoreButton
                  link={
                    CONTRACT_ROUTE_PATHS.anniversaryDate.to +
                    "?" +
                    serializeParams({
                      gainerIds: [userAccount?.agent?.id],
                    })
                  }
                />
              </Flex>
            }
            value={numberOrZero(contractStatuses?.insuranceContractAnniversaryDatesCount)}
          />
        </Col>

        <Col span={12}>
          <InfoCard
            disabled={isAnniversaryDatesLoansDisabled}
            label={
              <Flex align="center" justify="center">
                <Button
                  disabled={isAnniversaryDatesLoansDisabled}
                  variant="filled"
                  size="large"
                  color="cyan"
                  style={{ fontSize: 20 }}
                  icon={<AntIcon type="exception" />}
                />

                <span style={{ paddingLeft: 12, fontSize: titleSize }}>
                  {t("dashboard.contractStatuses.anniversaryDatesLoans")}
                </span>

                <ShowMoreButton
                  link={
                    CONTRACT_ROUTE_PATHS.fixationAnniversaryDate.to +
                    "?" +
                    serializeParams({
                      gainerIds: [userAccount?.agent?.id],
                    })
                  }
                />
              </Flex>
            }
            value={numberOrZero(contractStatuses?.loanContractAnniversaryDatesCount)}
          />
        </Col>
      </Row>
    </div>
  );
};
